// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"IP-z","categoryName":"JP-z","categoryNameSearchHeader":"KP-z","categoryContent":"LP-z","bottomAligned":"MP-z","image":"NP-z","imageNoBackground":"OP-z"};